import { PALETTE } from '@dealstack/shared/lib/common/business/stampDesign';

const BRAND = PALETTE.brand;
const OVERLAP_RED = '#e03131';

/** The ring around a box: red while it overlaps another, brand blue while selected. */
export const selectionShadowFor = (selected: boolean, overlapping: boolean): string => {
	if (overlapping) {
		return `0 0 0 2px ${OVERLAP_RED}, 0 0 0 4px rgba(224, 49, 49, 0.25)`;
	}
	return selected ? `0 0 0 2px ${BRAND}, 0 0 0 4px rgba(13, 94, 242, 0.25)` : 'none';
};
